import Header from "../../components/feature/Header";
import Breadcrumbs from "../../components/feature/Breadcrumbs";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import SEO from "../../components/feature/SEO";
import { useNoIndex } from "../../hooks/useNoIndex";

export default function PoliticaPrivacidad() {
  useNoIndex();

  return (
    <div className="min-h-screen bg-white">
      <SEO ogImage="https://persianas-toldos-malaga.es/og/og-default.jpg" ogType="website" />
      <Header />
      <Breadcrumbs />
      <main>
        <section className="py-16 md:py-24">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-text-primary mb-3">
              Política de Privacidad
            </h1>
            <p className="font-body text-base text-text-secondary mb-12">
              Tratamiento de datos personales conforme al Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica de Protección de Datos y Garantía de Derechos Digitales (LOPDGDD).
            </p>

            <div className="space-y-10 font-body text-base text-text-secondary leading-relaxed">
              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  1. Responsable del tratamiento
                </h2>
                <p className="mb-2">
                  De conformidad con lo establecido en el artículo 13 del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016 (RGPD), se informa al usuario de que el responsable del tratamiento de sus datos personales es:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-3">
                  <li><strong className="text-text-primary">Denominación social:</strong> Persianas Toldos Málaga</li>
                  <li><strong className="text-text-primary">Domicilio social:</strong> Calle Pacífico 54, 29003 Málaga, España</li>
                  <li><strong className="text-text-primary">Teléfono:</strong> +34 951 12 07 70</li>
                  <li><strong className="text-text-primary">Correo electrónico general:</strong> info@persianas-toldos-malaga.es</li>
                  <li><strong className="text-text-primary">CIF:</strong> B93847562</li>
                  <li><strong className="text-text-primary">Correo electrónico del Delegado de Protección de Datos (DPO):</strong> privacidad@persianas-toldos-malaga.es</li>
                </ul>
                <p className="mt-3">
                  Si tiene alguna duda sobre el tratamiento de sus datos personales, puede contactar directamente con nuestro Delegado de Protección de Datos a través de la dirección de correo electrónico indicada anteriormente.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  2. Datos que recopilamos
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga recopila y trata los siguientes datos personales de los usuarios:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li><strong className="text-text-primary">Datos de contacto:</strong> nombre y apellidos, dirección de correo electrónico, número de teléfono y ciudad de residencia, facilitados a través del formulario de contacto o presupuesto.</li>
                  <li><strong className="text-text-primary">Datos de navegación:</strong> dirección IP, tipo de dispositivo, sistema operativo, navegador utilizado, páginas visitadas y tiempo de permanencia, recogidos mediante cookies analíticas (Google Analytics 4), siempre previo consentimiento del usuario.</li>
                  <li><strong className="text-text-primary">Datos de comunicaciones:</strong> contenido de los mensajes enviados a través de los formularios de contacto, correo electrónico o WhatsApp.</li>
                </ul>
                <p className="mt-3">
                  No se solicitan datos especialmente protegidos conforme al artículo 9 del RGPD (datos relativos a la salud, creencias religiosas, filosóficas, origen étnico, opiniones políticas, etc.).
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  3. Finalidad del tratamiento
                </h2>
                <p className="mb-2">
                  Los datos personales que nos facilite serán tratados con las siguientes finalidades:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li><strong className="text-text-primary">Gestión de presupuestos y solicitudes:</strong> atender sus consultas, elaborar presupuestos personalizados y coordinar visitas técnicas para la reparación, instalación o motorización de persianas, toldos y mosquiteras.</li>
                  <li><strong className="text-text-primary">Atención al cliente:</strong> resolver dudas, incidencias, reclamaciones o solicitudes de información sobre nuestros servicios.</li>
                  <li><strong className="text-text-primary">Envío de comunicaciones comerciales:</strong> enviarle información sobre promociones, novedades y servicios relacionados con nuestro negocio, siempre y cuando haya otorgado su consentimiento expreso mediante la casilla habilitada al efecto.</li>
                  <li><strong className="text-text-primary">Análisis y mejora del sitio web:</strong> mejorar la experiencia de navegación y optimizar el rendimiento de nuestro sitio web mediante el análisis estadístico del tráfico, siempre previo consentimiento.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  4. Base jurídica del tratamiento
                </h2>
                <p className="mb-2">
                  El tratamiento de sus datos personales se basa en las siguientes bases jurídicas conforme al artículo 6 del RGPD:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li><strong className="text-text-primary">Consentimiento del interesado:</strong> cuando remite sus datos a través del formulario de contacto o presupuesto, marcando la casilla de aceptación de la Política de Privacidad.</li>
                  <li><strong className="text-text-primary">Ejecución de un contrato o aplicación de medidas precontractuales:</strong> cuando los datos son necesarios para la elaboración de un presupuesto o la prestación del servicio contratado.</li>
                  <li><strong className="text-text-primary">Interés legítimo:</strong> para la gestión interna de solicitudes, la seguridad de la web y la prevención de fraudes.</li>
                  <li><strong className="text-text-primary">Obligación legal:</strong> para el cumplimiento de obligaciones fiscales, contables y administrativas derivadas de la prestación de servicios.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  5. Plazo de conservación
                </h2>
                <p className="mb-2">
                  Sus datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recogidos y para determinar las posibles responsabilidades que pudieran derivarse de dicha finalidad y del tratamiento de los datos.
                </p>
                <p className="mb-2">
                  Como norma general, los datos de contacto facilitados a través de los formularios se conservarán durante un plazo máximo de <strong className="text-text-primary">cinco (5) años</strong> desde la última interacción o contacto con el usuario, salvo que se solicite su supresión con anterioridad.
                </p>
                <p>
                  Una vez transcurrido dicho plazo, los datos serán bloqueados y posteriormente eliminados de forma segura, conservándose únicamente aquellos necesarios para cumplir con obligaciones legales o resolución de litigios.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  6. Destinatarios de los datos y encargados del tratamiento
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga no cede, vende ni transfiere sus datos personales a terceros sin su consentimiento previo y expreso, salvo en los supuestos legalmente previstos.
                </p>
                <p className="mb-2">
                  No obstante, para la correcta prestación de nuestros servicios, sus datos podrán ser comunicados a los siguientes encargados del tratamiento:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li><strong className="text-text-primary">Infomaniak:</strong> proveedor de hosting y servicios de almacenamiento web.</li>
                  <li><strong className="text-text-primary">Google LLC:</strong> proveedor de servicios de análisis estadístico (Google Analytics 4), siempre y cuando haya otorgado su consentimiento para el uso de cookies analíticas.</li>
                </ul>
                <p className="mt-3">
                  Dichos encargados han suscrito los correspondientes contratos de encargo de tratamiento, garantizando el cumplimiento de las medidas de seguridad y confidencialidad exigidas por la normativa vigente.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  7. Derechos del usuario
                </h2>
                <p className="mb-2">
                  De conformidad con los artículos 15 a 22 del RGPD, el usuario tiene derecho a:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li><strong className="text-text-primary">Derecho de acceso (art. 15):</strong> obtener confirmación de si se están tratando sus datos personales y, en tal caso, acceder a la información sobre dicho tratamiento.</li>
                  <li><strong className="text-text-primary">Derecho de rectificación (art. 16):</strong> solicitar la corrección de datos inexactos o la actualización de datos incompletos.</li>
                  <li><strong className="text-text-primary">Derecho de supresión (art. 17):</strong> solicitar la eliminación de sus datos cuando ya no sean necesarios para los fines para los que fueron recogidos.</li>
                  <li><strong className="text-text-primary">Derecho de oposición (art. 21):</strong> oponerse al tratamiento de sus datos, en particular para fines de marketing directo.</li>
                  <li><strong className="text-text-primary">Derecho de limitación del tratamiento (art. 18):</strong> solicitar la limitación del tratamiento en determinadas circunstancias.</li>
                  <li><strong className="text-text-primary">Derecho de portabilidad (art. 20):</strong> recibir sus datos en un formato estructurado, de uso común y lectura mecánica, y transmitirlos a otro responsable del tratamiento.</li>
                  <li><strong className="text-text-primary">Derecho a no ser objeto de decisiones automatizadas (art. 22):</strong> no ser objeto de una decisión basada únicamente en un tratamiento automatizado que produzca efectos jurídicos significativos sobre usted.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  8. Cómo ejercer sus derechos
                </h2>
                <p className="mb-2">
                  Para ejercer cualquiera de los derechos mencionados anteriormente, el usuario puede dirigirse a Persianas Toldos Málaga mediante:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li>Correo electrónico a: <strong className="text-text-primary">privacidad@persianas-toldos-malaga.es</strong></li>
                  <li>Correo postal a: Calle Pacífico 54, 29003 Málaga, España</li>
                </ul>
                <p className="mt-3">
                  La solicitud deberá incluir el nombre y apellidos del interesado, copia del documento nacional de identidad u otro documento identificativo válido, petición en la que se concreta la solicitud, domicilio a efectos de notificaciones, fecha y firma del solicitante. En caso de actuar mediante representante, se deberá aportar copia del documento acreditativo de la representación.
                </p>
                <p className="mt-3">
                  Asimismo, si considera que el tratamiento de sus datos personales vulnera la normativa vigente, tiene derecho a presentar una reclamación ante la <strong className="text-text-primary">Agencia Española de Protección de Datos (AEPD)</strong>, con domicilio en la Calle Jorge Juan, 6, 28001 Madrid, o a través de su sitio web: <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">www.aepd.es</a>.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  9. Medidas de seguridad
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a los que están expuestos.
                </p>
                <p className="mb-2">
                  Entre las medidas implementadas se encuentran:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li>Protocolo de seguridad SSL/TLS en todas las conexiones al sitio web.</li>
                  <li>Copias de seguridad periódicas de los datos almacenados en los servidores.</li>
                  <li>Accesos restringidos a los datos personales, limitados al personal autorizado.</li>
                  <li>Cumplimiento de las medidas de seguridad exigidas por el artículo 32 del RGPD.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  10. Cambios en la política de privacidad
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga se reserva el derecho a modificar la presente Política de Privacidad en cualquier momento, notificando al usuario de dichos cambios con una antelación mínima de <strong className="text-text-primary">treinta (30) días</strong> naturales antes de su entrada en vigor, salvo que la modificación responda a un requerimiento legal o de la autoridad de control.
                </p>
                <p>
                  Se recomienda al usuario consultar periódicamente esta sección para mantenerse informado de cualquier actualización. Última actualización: 20 de mayo de 2026.
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}